import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import Button from 'app/components/general/Button';
import history from 'app/routes/history';
import NotFoundImage from 'app/images/404.png';

interface IProps {
  match: any;
}
export default class NotFound extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="container">
          <div className="row">
            <div className="col text-center with-margin-top-extra">
              <h1>You ran into a problem</h1>
              <Button
                onClick={(): void => {
                  // Reloads and redirects
                  window.location.replace('/dashboard');
                }}
                className="btn btn-1 large with-margin-top"
              >
                Back to Dashboard
              </Button>
              <img
                className="not-found-image"
                src={NotFoundImage}
                alt="Not found"
              />
            </div>
          </div>
        </div>
      </RenderContent>
    );
  }
}
